import { padStart } from "lodash";

export default function minutesUntilTimer(date: Date) {
  const minutes = String(Math.ceil((Number(date) - Number(new Date())) / 60000));
  return `00:${padStart(minutes, 2, "0")}`;
}
